import { render } from "./LayoutEmpty.vue?vue&type=template&id=0eb1bbca"
const script = {}

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__